// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-container[data-v-784b4970] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n}", ""]);
// Exports
module.exports = exports;
